export const isHtmlTable = (element: Element) => element.nodeName === 'TABLE';
